import React from 'react';
import styled from 'styled-components';
//import { Link } from 'gatsby';
//import tw from 'tailwind.macro';
import tw from 'twin.macro';
import { Dot } from '../../styles/GlobalStyles';

// const ProgramBox = styled.div`
//   /* ${tw`w-full flex text-xl flex-wrap sm:flex-nowrap`} */
//   ${tw``}
// `;

const ProgramHour = styled.div`
  ${tw`w-full w-36 text-dv2021-600 font-bold`}
`;

const ProgramContent = styled.div`
  ${tw`mb-8`}
`;

const ProgramTitle = styled.p`
  ${tw`text-dv2021-600 uppercase font-bold mb-3`}
`;

const ProgramArticle = styled.p`
  ${tw`font-semibold leading-tight`}
`;

const ProgramAuthor = styled.p`
  ${tw`mb-2`}
`;

export default function Dan1() {
  return (
    <>
      <div>
        <p className="text-3xl font-bold text-center mt-16 mb-12">
          1<Dot>.</Dot> dan &ndash; 9<Dot>.</Dot> 6<Dot>.</Dot> 2021
        </p>

        <div className="grid grid-cols-1 md:grid-cols-7 text-lg gap-x-14">
          <ProgramHour>11.00&ndash;11.30</ProgramHour>
          <ProgramContent className="md:col-span-6">
            <p className="font-bold uppercase text-dv2021-600 mb-2 flex-grow">
              Otvoritev konference
            </p>
            <p>Dr. Andrej Sotlar, dekan Fakultete za varnostne vede Univerze v Mariboru</p>
            <p>Dr. Zdravko Kačič, rektor Univerze v Mariboru</p>
            <p>
              Mag. Bojan Majcen, generalni direktor Uprave Republike Slovenije za izvrševanje
              kazenskih sankcij
            </p>
            <p>
              Dr. Maja Modic, predsednica Programsko-organizacijskega odbora Dnevov varstvoslovja{' '}
            </p>
          </ProgramContent>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-7 text-lg gap-x-14">
          <ProgramHour>11.30&ndash;13.00</ProgramHour>
          <ProgramContent className="md:col-span-6">
            Plenarna okrogla miza
            <br />
            <ProgramTitle>
              Delovanje slovenskih varnostnih, obrambnih in zaščitno-reševalnih sil v
              osamosvojitveni vojni
            </ProgramTitle>
            <p>Moderator: Andrej Sotlar</p>
            <p>Razpravljavci: Mihael Brejc, Boris Žnidarič, Milivoj Dolščak, Janez Slapar </p>
          </ProgramContent>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-7 text-lg gap-x-14">
          <ProgramHour>13.00&ndash;13.05</ProgramHour>
          <ProgramContent className="md:col-span-6">
            <ProgramTitle>Odmor</ProgramTitle>
          </ProgramContent>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-7 text-lg gap-x-14">
          <ProgramHour>13.05&ndash;14.05</ProgramHour>
          <ProgramContent className="md:col-span-6">
            Sekcija
            <br />
            <ProgramTitle className="mb-4">Penologija</ProgramTitle>
            <p className="mb-3">Moderatorka: Lana Cvikl</p>
            <ProgramArticle>Tretma obsojencev – vizija ali utopija?</ProgramArticle>
            <ProgramAuthor>Nastja Holc</ProgramAuthor>
            <ProgramArticle>Mnenje prebivalcev Slovenije o probaciji</ProgramArticle>
            <ProgramAuthor>Branko Lobnikar in Emanuel Banutai</ProgramAuthor>
            <ProgramArticle>Izkušnje slovenske probacije v času epidemije</ProgramArticle>
            <ProgramAuthor>Danijela Mrhar Prelić in Emanuel Banutai</ProgramAuthor>
            <ProgramArticle>
              Izzivi projekta HOPE – iniciativa celostnega preprečevanja radikalizacije
            </ProgramArticle>
            <ProgramAuthor>Emanuel Banutai in Danijela Mrhar Prelić </ProgramAuthor>
            <ProgramArticle>
              Učinkovitost pravnih sredstev v slovenskem zaporskem sistemu
            </ProgramArticle>
            <ProgramAuthor>Lana Cvikl</ProgramAuthor>
          </ProgramContent>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-7 text-lg gap-x-14">
          <ProgramHour>14.05&ndash;14.10</ProgramHour>
          <ProgramContent className="md:col-span-6">
            <ProgramTitle>Odmor</ProgramTitle>
          </ProgramContent>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-7 text-lg gap-x-14">
          <ProgramHour>14.10&ndash;15.40</ProgramHour>
          <ProgramContent className="md:col-span-6">
            Okrogla miza
            <br />
            <ProgramTitle>
              V skupnost usmerjeno policijsko delo – proklamirana vodilna dejavnost slovenske
              policije ali mit?
            </ProgramTitle>
            <p>Moderator: Gorazd Meško</p>
            <p>
              Razpravljavci: Darko Anželj, Tomaž Pečjak, Damir Ivančić, Branko Lobnikar, Marija
              Mikulan, Peter Misja, Maja Modic
            </p>
          </ProgramContent>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-7 text-lg gap-x-14">
          <ProgramHour>15.40&ndash;15.45</ProgramHour>
          <ProgramContent className="md:col-span-6">
            <ProgramTitle>Odmor</ProgramTitle>
          </ProgramContent>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-7 text-lg gap-x-14">
          <ProgramHour>15.45&ndash;16.55</ProgramHour>
          <ProgramContent className="md:col-span-6">
            Sekcija
            <br />
            <ProgramTitle className="mb-4">Informacijska varnost</ProgramTitle>
            <p className="mb-2">Moderator: Anže Mihelič</p>
            <ProgramArticle>Kibernetska varnost pametnih omrežij</ProgramArticle>
            <ProgramAuthor>Matjaž Trunkelj in Blaž Markelj</ProgramAuthor>
            <ProgramArticle>
              Pregled uporabe veriženja blokov za zagotavljanje varnosti podatkov v pametnih
              zdravstvenih sistemih
            </ProgramArticle>
            <ProgramAuthor>Žiga Kodrič, Luka Jelovčan in Simon Vrhovec</ProgramAuthor>
            <ProgramArticle>
              Empirični pristopi k napovedovanju informacijskovarnostnega vedenja
            </ProgramArticle>
            <ProgramAuthor>Špela Grilc, Anže Mihelič in Kaja Prislan</ProgramAuthor>
            <ProgramArticle>
              Izbira načina upravljanja informacijske varnosti v organizacijah: Odločitveni model in
              primeri uporabe
            </ProgramArticle>
            <ProgramAuthor>Luka Jelovčan, Anže Mihelič in Kaja Prislan</ProgramAuthor>
            <ProgramArticle>Varnostnomotivacijska teorija v organizacijskih okoljih</ProgramArticle>
            <ProgramAuthor>Anže Mihelič in Simon Vrhovec</ProgramAuthor>
            <ProgramArticle>
              Zgodovinski pregled literature s področja informacijske varnosti
            </ProgramArticle>
            <ProgramAuthor>Anže Mihelič, Zala Gujtman, Luka Jelovčan in Kaja Prislan</ProgramAuthor>
          </ProgramContent>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-7 text-lg gap-x-14">
          <ProgramHour>16.55&ndash;17.00</ProgramHour>
          <ProgramContent className="md:col-span-6">
            <ProgramTitle>Odmor</ProgramTitle>
          </ProgramContent>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-7 text-lg gap-x-14">
          <ProgramHour>17.00&ndash;18.30</ProgramHour>
          <ProgramContent className="md:col-span-6">
            Sekcija
            <br />
            <ProgramTitle className="mb-4">Varstvoslovje</ProgramTitle>
            <p className="mb-2">Moderator: Aleš Bučar Ručman</p>
            <ProgramArticle>English in Uniform</ProgramArticle>
            <ProgramAuthor>Mojca Kompara Lukančič</ProgramAuthor>
            <ProgramArticle>
              Stališča študentov varstvoslovja do uporabe orodij za učenje in poučevanje tujega
              jezika stroke na daljavo
            </ProgramArticle>
            <ProgramAuthor>Tilen Smajla in Eva Podovšovnik Axelsson</ProgramAuthor>
            <ProgramArticle>Digitalno pripovedovanje zgodb in ozaveščanje</ProgramArticle>
            <ProgramAuthor>Eva Bertok in Danijela Frangež</ProgramAuthor>
            <ProgramArticle>
              Uporaba kratkega vprašalnika za merjenje dimenzij osebnosti po teoriji velikih pet v
              varstvoslovju
            </ProgramArticle>
            <ProgramAuthor>Natalija Žarn in Vanja Erčulj</ProgramAuthor>
            <ProgramArticle>
              Uporaba pravice prostega preudarka v upravnih in prekrškovnih zadevah
            </ProgramArticle>
            <ProgramAuthor>Bojan Tičar</ProgramAuthor>
            <ProgramArticle>
              Multisenzorni prostor in vključevanje priseljencev v lokalno okolje
            </ProgramArticle>
            <ProgramAuthor>Eva Bertok, Aleš Bučar Ručman in Danijela Frangež</ProgramAuthor>
            <ProgramArticle>
              Travmatski stres pri prostovoljnih gasilcih Gasilske zveze Maribor
            </ProgramArticle>
            <ProgramAuthor>Timi Berghaus, Tinkara Pavšič Mrevlje in Matevž Bren</ProgramAuthor>
          </ProgramContent>
        </div>
      </div>
    </>
  );
}
